import { Component } from '@angular/core';

@Component({
  selector: 'rnpl-localization',
  templateUrl: './localization.component.html',
  styleUrls: ['./localization.component.scss']
})
export class LocalizationComponent {


}
